import { useState } from "react";
import { Dialog } from "@headlessui/react";

import Input from "../../controls/Input";

export default function EditScannedItemModal(props) {
  const { receivingItem, setOpen, onConfirm, production_id } = props;

  const [amountInUse, setAmountInUse] = useState(
    receivingItem?.ingredient_amount_used
      ? parseFloat(receivingItem.ingredient_amount_used)
      : 0,
  );
  const [error, setError] = useState("");

  const getBarcodeLast9 = (barcode) => {
    if (!barcode) return "N/A";
    return barcode.slice(-9);
  };

  const handleSubmit = () => {
    setError("");

    const finalAmount = parseFloat(amountInUse);

    if (isNaN(finalAmount) || finalAmount < 0) {
      setError("Amount must be greater than or equal to 0");
      return;
    }

    const maxAmount = parseFloat(receivingItem?.received_amount || 0);
    if (finalAmount > maxAmount) {
      setError(
        `Amount cannot exceed ${maxAmount.toFixed(2)} ${receivingItem?.unit_of_measure || ""}`,
      );
      return;
    }

    // Prepare item with the updated amount
    const itemWithAmount = {
      barcode: receivingItem.barcode,
      amount_used: finalAmount,
      production_id: production_id,
    };

    onConfirm(itemWithAmount);
  };

  const handleCancel = () => {
    setOpen({
      childComponent: null,
      open: false,
    });
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmountInUse(value);
    setError("");
  };

  return (
    <div>
      <div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-medium font-bold leading-6 text-gray-900"
          >
            Barcode: {getBarcodeLast9(receivingItem?.barcode)}
          </Dialog.Title>
          <div className="mt-4 text-left">
            <div className="mb-4">
              <Input
                label="In Stock Amount"
                name="in_stock"
                type="number"
                step="0.01"
                value={receivingItem?.in_stock || 0}
                disabled={true}
                labelOn={true}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-100 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">
                Unit: {receivingItem?.unit_of_measure || ""}
              </p>
            </div>

            <div className="mb-4">
              <Input
                label="Amount in Use"
                name="ingredient_amount_used"
                type="number"
                step="0.01"
                min="0"
                max={receivingItem?.in_stock || 0}
                value={amountInUse}
                onChange={handleAmountChange}
                labelOn={true}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">
                Unit: {receivingItem?.unit_of_measure || ""}
              </p>
            </div>

            {error && (
              <p className="text-sm text-red-500 font-semibold mt-1">{error}</p>
            )}
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 grid grid-flow-row-dense grid-cols-2 gap-3 items-center">
        <button
          type="button"
          className="inline-flex w-full justify-center items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="inline-flex w-full justify-center items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:col-start-2 sm:mt-0"
          onClick={handleSubmit}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}
